var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarningTriangle1614 = function SvgWarningTriangle1614(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF3D3D",
    d: "M8 10.5v.875M8 4.813v4.812M.855 12.504 7.132 1.519a1 1 0 0 1 1.736 0l6.277 10.985A1 1 0 0 1 14.277 14H1.723a1 1 0 0 1-.868-1.496Z"
  })));
};
export default SvgWarningTriangle1614;